export default __webpack_public_path__ + "static/media/tostrike.b7d507a2.svg";